/* eslint-disable import/no-webpack-loader-syntax */
import { captureException } from '@sentry/vue';
import { boot } from 'quasar/wrappers';

import { NotificationApi } from 'SharedDir/backend/api/index';
import { useAuthStore } from 'SharedDir/stores/auth.store';
import WebPushManager from 'SharedDir/utils/web-push-manager';

export default boot(async ({ store }) => {
  if (!('serviceWorker' in navigator)) {
    return;
  }
  try {
    const state = useAuthStore(store);
    const registration = await navigator.serviceWorker.register('/web-push.worker.js');
    await registration.update();
    const webPushManager = new WebPushManager(registration, NotificationApi);
    state.$onAction(({ name, args, after }) => {
      if (name === 'setToken') {
        const [token] = args;
        if (!state.isAuthenticated && token) {
          after(() => {
            webPushManager.subscribe();
          });
        }
        if (state.isAuthenticated && !token) {
          after(() => {
            webPushManager.unsubscribe();
          });
        }
      }
    });
    if (state.isAuthenticated) {
      webPushManager.subscribe();
    }
  } catch (e) {
    captureException(e);
    throw e;
  }
});
